/* global $ */

const Translations = {
  create(node, props) {
    this.node = node;
    this.props = props;
    this.translationTemplate = document.getElementById('translation-template').innerHTML;

    this.createListeners();
  },

  /**
   * Create event listeners
   * @return void
   */
  createListeners() {
    $(this.node).on('blur', '.js-translations-row input', (e) => {
      this.updateRow(this.getRow(e.currentTarget));
    });

    $(this.node).on('click', '.js-translations-row .js-translation-remove', (e) => {
      this.destroyRow(this.getRow(e.currentTarget));
    });

    $(this.node).on('click', '.js-translation-add', (e) => {
      const $row = $(e.currentTarget).parents('.js-translations-add');
      this.storeRow($row);
    });
  },

  /**
   * Return the row based on an element inside the row
   * @param {HTMLElement} htmlNode
   * @returns {object}
   */
  getRow(htmlNode) {
    return $(htmlNode).parents('.js-translations-row');
  },

  /**
   * Create a new row
   * @param {object} $row
   * @return {void}
   */
  storeRow($row) {
    const data = {
      key: $row.find('[data-field="key"]').val(),
      prefix: $row.find('[data-field="prefix"]').val(),
      translations: this.getTranslations($row),
    };

    if (!this.validate(data)) {
      return;
    }

    window.axios.post(`${this.props.translationStore}`, data)
      .then(() => this.createRow(data))
      .then(() => this.emptyAddForm($row))
      .catch(this.captureError);
  },

  /**
   * Update existing row
   * @param {object} $row
   * @return {void}
   */
  updateRow($row) {
    const key = $row.data('key');
    const prefix = $row.data('prefix');
    const values = this.getTranslations($row);

    window.axios.post(`${this.props.translationUpdate}/${key}`, {
      _method: 'PUT',
      prefix,
      translations: values,
    })
      .then(res => this.renderToast(res.data))
      .catch(this.captureError);
  },

  /**
   * Remove row
   * @param {object} $row
   * @return {void}
   */
  destroyRow($row) {
    if (!window.confirm(this.props.translationSure)) { // eslint-disable-line no-alert
      return;
    }

    const key = $row.data('key');
    const prefix = $row.data('prefix');

    this.removeRow($row);

    window.axios.post(`${this.props.translationDestroy}/${key}`, {
      _method: 'DELETE',
      prefix,
    })
      .then(res => this.renderToast(res.data))
      .catch(this.captureError);
  },

  /**
   * Create a new row element with data
   * @param {object} data
   * @return {void}
   */
  createRow(data) {
    let template = this.translationTemplate;
    template = template.replace(/##key##/g, data.key);
    template = template.replace(/##prefix##/g, data.prefix);

    const $row = $(template);

    Object.keys(data.translations).forEach((translationKey) => {
      const translationValue = data.translations[translationKey];
      const $translationInput = $row.find(`[data-language="${translationKey}"]`);

      if (!$translationInput.length) {
        return;
      }

      $translationInput.val(translationValue);
    });

    $(this.node).find('.js-translations-add').after($row);
  },

  /**
   * Validate new translation data
   * @param {object} data
   * @returns {boolean}
   */
  validate(data) {
    return data.key !== '';
  },

  /**
   * Empty input elements on row
   * @param {object} $row
   * @return {void}
   */
  emptyAddForm($row) {
    $row.find('input').toArray().forEach((input) => {
      if (input.getAttribute('data-field') === 'prefix') {
        return;
      }

      input.value = '';
    });
  },

  /**
   * Remove row element
   * @param {object} $row
   * @return {void}
   */
  removeRow($row) {
    $row.remove();
  },

  /**
   * Return translation key/values, e.g.
   * {nl_NL: 'hallo', en_EN: 'hello'}
   * @param {object} $row
   * @returns {object}
   */
  getTranslations($row) {
    return $row.find('[data-language]').toArray().reduce((acc, input) => {
      acc[input.getAttribute('data-language')] = input.value;
      return acc;
    }, {});
  },

  /**
   * Show toast
   * @param {Object} data
   * @return {void}
   */
  renderToast(data) {
    window.toaster.show(data.message, 3000, 'success');
  },

  /**
   * Show error
   * @param {Error} err
   * @return {void}
   */
  captureError(err) {
    window.toaster.show(err.response.data.message, 3000, 'danger');
    console.error(err); // eslint-disable-line no-console
  },
};

export default Translations;
